module.exports = __webpack_public_path__ + "static/media/DetailedTemplate.9ede15b3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/documents/DetailedTemplate.pdf
// module id = 3837
// module chunks = 0